export default {"src":"/pro/_next/static/media/skr.143eb451.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};